import { Icon, message, Upload } from "antd";
import { UploadFile } from "antd/lib/upload/interface";
import api, { WisdomCashierSeal } from "api";
import { AppAction, AppForm, AppFormItemEnum, AppFormLayout, AppFormPageProps } from 'qcc';
import React, { Fragment } from 'react';
export default class PosBankEditForm extends React.PureComponent<AppFormPageProps> {
  refAppForm = React.createRef<AppForm>()
  state = {
    fileList: [] as UploadFile[],
    imgList: [] as any,
    loading: false,
    beforeUpload: true,
    sealUrl: this.props.formData.sealUrl,

  }
  // 保存
  save = async (formData?: WisdomCashierSeal) => {
    let sealUrl = this.state.sealUrl
    console.log("sealUrl", sealUrl);
    let { isEnabled } = formData;
    if (isEnabled !== 1) {
      formData = { ...formData }
    }
    formData.sealUrl = this.state.sealUrl;
    return this.props.mode === 1 ? await api.wisdomcashierseal.create(formData) : await api.wisdomcashierseal.update(formData);
  }
  beforeUpload = (file: any) => {
    console.log('file11', file)
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("只能上传JPG/PNG格式的图片!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("最大上传2MB图片!");
    }
    return isJpgOrPng && isLt2M;
  };
  getBase64 = (img: any, callback: any) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  // 上传印章图片
  handleChange = async (file: any) => {
    let { sealUrl, fileList } = this.state;
    fileList.shift();
    let imgUrl = "";
    if (file.file.status === "uploading") {
      this.setState({ loading: true });
      return;
    }
    if (file.file.status === "done") {
      this.setState({ loading: false });
    }
    if (file.file.response && file.file.response.code === 200) {
      imgUrl = file.file.response.data;
    } else {
      return;
    }
    this.refAppForm.current.onItemValueChange('sealUrl', imgUrl)
    this.setState({ file, sealUrl: imgUrl });
  };
  beforeSave = async () => {
    if (!this.state.sealUrl || this.state.sealUrl === '') {
      AppAction.warnMsg("请选择印章！")
      return false
    }
    return true
  }
  render() {
    const { fileList, sealUrl } = this.state
    let { formData, mode, id } = this.props;
    let { projectId } = formData;
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? "loading" : "plus"} />
        <div className="ant-upload-text">上传图片</div>
      </div>
    );
    return (<AppFormLayout defaultButton mode={this.props.mode} >
      <AppFormLayout.Form>
        <AppForm ref={this.refAppForm} entity='wisdom_cashier_seal' loadingData={false} mode={mode} keyValue={id} formData={formData}
          save={this.save}
          // beforeSave={this.beforeSave}
          afterSave={() => { this.props.afterSave && this.props.afterSave() }}>
          <AppForm.Section labelWidth={120} >
            <AppForm.Item label='印章编号'
              field='sealCode'
              itemType={AppFormItemEnum.input} readonly={true} />
            <AppForm.Item label='印章名称'
              field='sealName'
              itemType={AppFormItemEnum.input} unRepeat scopeField='project_id' req />
            <AppForm.Item label='所属企业'
              field='customerId' placeholder="请选择企业"
              itemType={AppFormItemEnum.select}
              renderOptions={() => api.posenterprisercb.getEntOptions({ projectId })} req />
            <AppForm.Item label='备注'
              field='remark'
              itemType={AppFormItemEnum.input} />
            <AppForm.Item label='上传印章'
              field='sealUrl' value={sealUrl} req
              render={() => {
                return (
                  <Fragment>
                    <Upload
                      name="file"
                      listType="picture-card"
                      className="avatar-uploader"
                      showUploadList={false}
                      action="/api/public/uploadSeal"
                      beforeUpload={this.beforeUpload}
                      onChange={this.handleChange}
                    >
                      {this.state.sealUrl ? <img src={this.state.sealUrl} alt="avatar" style={{ width: '100%', height: '86px' }} /> : uploadButton}
                    </Upload>
                    {/* <Upload
                      showUploadList={true}
                      action="/api/public/uploadSeal"
                      beforeUpload={this.beforeUpload}
                      onChange={this.handleChange}>

                      <Button disabled={this.state.fileList.length > 0 ? true : false}　>
                        <Icon type={this.state.loading ? "loading" : "plus"} /> 上传模板
                            　　　　</Button>
                    </Upload> */}
                    图片大小：166*166，文件大小：50k
                  </Fragment>

                )
              }
              } />
          </AppForm.Section>
        </AppForm>
      </AppFormLayout.Form>
    </AppFormLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/sealmanage/SealManageEditForm.tsx